import { render } from "../../_snowpack/pkg/react-dom.js";
export function uiTest(testBody) {
  return async function() {
    const div = document.createElement("div");
    await testBody(div);
    render(null, div);
  };
}
